import api from "./api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils";

export const ENDPOINT_TRAFFIC_VIOLATION_TYPES = API_URL_VERSION + "tipo-infracao";
export const ENDPOINT_TRAFFIC_VIOLATION_TYPES_LIST = ENDPOINT_TRAFFIC_VIOLATION_TYPES + "/listar";

export const trafficViolationTypeService = {
  list: async (params) => {
    try {
      const searchParams = toSearchFilter(params);
      const response = await api.post(ENDPOINT_TRAFFIC_VIOLATION_TYPES_LIST, searchParams);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "traffic-violation-type.messages.errors.list";
    }
  },
  lookup: async () => {
    try {
      const response = await api.get(ENDPOINT_TRAFFIC_VIOLATION_TYPES_LIST);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "traffic-violation-type.messages.errors.list";
    }
  },
};
